
import {
  updatePlants
} from '../plant-items/actions';

import { loadFireBase } from '../../lib/firebase';

export const ADD_PLANT_TOGGLE_MODAL = 'ADD_PLANT_TOGGLE_MODAL';
export const ADD_PLANT_SUCCESS = 'ADD_PLANT_SUCCESS';
export const ADD_PLANT_FAILURE = 'ADD_PLANT_FAILURE';

const firebase = loadFireBase();
const base = firebase.base;

export const toggleModal = (isActive) => ({
  type: ADD_PLANT_TOGGLE_MODAL,
  modal: isActive,
});

export const addPlantCall = (userId, inputValues) => {
  const id = Math.random().toString().split('.')[1];
  const bodyData = {
    data: {
      id,
      name: inputValues.plantName,
      userId,
      waterStartTime: inputValues.waterStartTime,
      wateringCycle: inputValues.wateringCycle,
    }
  };

  return base
    .push(`plants`, bodyData)
    .then((key) => {
      return [{ ...bodyData.data, key: key.key }];
    });
};

export const addPlantSuccess = (resp) => ({
  type: ADD_PLANT_SUCCESS,
  payload: resp,
});

export const addPlantError = (error) => ({
  type: ADD_PLANT_FAILURE,
  error: error,
});

export const addPlant = (userId, inputValues) => {
  return function(dispatch) {
    return addPlantCall(userId, inputValues)
    .then(
      resp => {
        dispatch(addPlantSuccess(resp));
        dispatch(updatePlants(resp))
      },
      error => dispatch(addPlantError(error))
    );
  }
};
